import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from '@mantine/core';

import { menuListOW, role } from "../../utils/globalVariables";

import WrapperHeaderTab from "../../layout/WrapperHeaderTab";
import WrapperTab from "../../layout/WrapperTab";
import HeaderNav from "../../layout/HeaderNav";

import LayoutAppShell from "../../layout/LayoutAppShell";
import Components from "../../pagesSub/dev/Components";
import DataInsert from "../../pagesSub/dev/DataInsert";
import JWT from "../../pagesSub/dev/JWT";
import KetentuanGaransi from "../../pagesSub/dev/KetentuanGaransi";

const DevIndex = () => {

    const { subMenu, tab } = useParams();
    const menu = menuListOW.dev.slug;
    const roleUser = role.owner;
    const slugLink = roleUser.subLevel.owner.slugLink;

    return (
        <LayoutAppShell
            stateMenuList={menuListOW}
            stateMenu={menu}
            stateLocalStorageIdleTimerName={roleUser.localStorageIdleTimeName}
        >
            {menuListOW.dev.subMenu.one.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <Components />
                </React.Fragment>
            }

            {menuListOW.dev.subMenu.two.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <DataInsert />
                </React.Fragment>
            }

            {menuListOW.dev.subMenu.three.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />
                    </WrapperHeaderTab>

                    <JWT />
                </React.Fragment>
            }

            {menuListOW.dev.subMenu.four.flag === subMenu &&
                <React.Fragment>
                    <WrapperHeaderTab>
                        <HeaderNav
                            stateMenuList={menuListOW}
                            stateMenu={menu}
                            stateSubMenu={subMenu}
                        />

                        <WrapperTab
                            stateNavigate={`/${slugLink}/${menu}/${subMenu}/`}
                            stateKeepMounted={false}
                        >
                            <Tabs.Tab value={menuListOW.dev.subMenu.four.tabs.one.flag}>
                                {menuListOW.dev.subMenu.four.tabs.one.name}
                            </Tabs.Tab>
                        </WrapperTab>
                    </WrapperHeaderTab>

                    <Tabs value={tab} keepMounted={false}>
                        <Tabs.Panel value={menuListOW.dev.subMenu.four.tabs.one.flag}>
                            <KetentuanGaransi />
                        </Tabs.Panel>
                    </Tabs>
                </React.Fragment>
            }
        </LayoutAppShell>
    )
}

export default DevIndex;